/**
 * KAN-759: правка заказа (позиции и переходы статуса) для карточки заказа и
 * модалки формирования заказа в CRM. Одна ошибка на обе мутации: новая правка
 * сбрасывает ошибку другой мутации.
 * KAN-755: промокод (применить, снять) со своей ошибкой promoError: её
 * показывает поле промокода, а не общий блок ошибки заказа.
 */
import { useOrderItemsMutation, useOrderPromoMutation, useOrderTransition } from '@/hooks/useOrders';
import type { CatalogId } from '@/types/catalog';
import type { OrderAction, OrderDetail } from '@/types/order';

export interface OrderEditor {
  /** Идёт сохранение правки или перехода. */
  pending: boolean;
  /** Ошибка последней правки или перехода (400/403/409). */
  error: unknown;
  add: (productId: CatalogId) => void;
  setQuantity: (index: number, quantity: number) => void;
  remove: (index: number) => void;
  runAction: (action: OrderAction, onSuccess?: (order: OrderDetail) => void) => void;
  /** Ошибка промокода (400 "не найден или не действует"). */
  promoError: unknown;
  applyPromo: (code: string) => void;
  removePromo: () => void;
}

export function useOrderEditor(orderId: string): OrderEditor {
  const items = useOrderItemsMutation(orderId);
  const transition = useOrderTransition(orderId);
  const promo = useOrderPromoMutation(orderId);

  return {
    pending: items.isPending || transition.isPending || promo.isPending,
    error: items.error ?? transition.error,
    add: (productId) => {
      transition.reset();
      promo.reset();
      items.mutate({ op: 'add', product_id: productId, quantity: 1 });
    },
    setQuantity: (index, quantity) => {
      transition.reset();
      promo.reset();
      items.mutate({ op: 'set_quantity', index, quantity });
    },
    remove: (index) => {
      transition.reset();
      promo.reset();
      items.mutate({ op: 'remove', index });
    },
    runAction: (action, onSuccess) => {
      items.reset();
      promo.reset();
      transition.mutate(action, onSuccess ? { onSuccess } : undefined);
    },
    promoError: promo.error,
    applyPromo: (code) => {
      items.reset();
      transition.reset();
      promo.mutate(code);
    },
    removePromo: () => {
      items.reset();
      transition.reset();
      promo.mutate(null);
    },
  };
}
